import { deerEndpoints } from 'Deer/constants/endpoints';
import { sendRequest } from 'api/sendRequest';

interface FetchFeaturesParams {
  type: string;
  status: string;
}

export const putFeaturesAPI = async ({ type, status }: FetchFeaturesParams) => {
  try {
    const url = deerEndpoints.featureManagement;

    const res = await sendRequest({
      url,
      method: 'PUT',
      credentials: 'include',
      queryParams: {
        type,
        status,
      },
    });

    // Check if the response was successful
    if (res && res.entity) {
      // Reload the page after a successful API call
      window.location.reload();
    }

    return res.entity;
  } catch (error) {
    console.error('Error while fetching data', error);
    throw new Error(error);
  }
};
